export enum BundleItemType {
  Activity = 'Activity'
}
